import { useEffect, useState } from 'react';
import { Collapse, ListItemButton, ListItemText } from 'components/mui';
import { ExpandLess, ExpandMore } from 'components/icons';
import styles from '../styles/cantab.module.css';
import ListSubmenuTabs from './ListSubmenuTabs';
import { shape, string } from 'prop-types';
import { APP_CAN_APPS_V3 } from 'constants/appNames';

/**
 * @component ListSubmenu
 * @param { Object } props
 * @param { object } props.tab
 * @returns { JSX.Element }
 */
function ListSubmenu({ tab, menuOpen, setMenuClose, activeTab }) {
	const [open, setOpen] = useState(false);

	const submenuContainsActiveTab = () => {
		if (!tab.subtabs) return false;
		return tab.subtabs.some((subtab) => {
			if (!subtab.url) return false;
			const subtabUrl = subtab.type === APP_CAN_APPS_V3 ? `/${APP_CAN_APPS_V3}${subtab.url}` : subtab.url;
			return activeTab === subtabUrl;
		});
	};

	const onOpen = () => {
		setOpen(!open);
	};

	useEffect(() => {
		if (!menuOpen) {
			setOpen(false);
		} else {
			setOpen(submenuContainsActiveTab());
		}
	}, [tab.name, menuOpen]);

	return (
		<>
			<ListItemButton className={styles.lm_list_btn} onClick={onOpen}>
				<ListItemText className={styles.lm_list_text} primary={tab.name} />
				{open ? (
					<ExpandLess className={styles.la_list_icon_open} />
				) : (
					<ExpandMore className={styles.la_list_icon_open} />
				)}
			</ListItemButton>
			<Collapse in={open} timeout="auto" unmountOnExit>
				{(tab.subtabs ?? []).map((subtab, index) => (
					<ListSubmenuTabs
						key={index}
						subtab={subtab}
						setMenuClose={setMenuClose}
						activeTab={activeTab}
					/>
				))}
			</Collapse>
		</>
	);
}

ListSubmenu.propTypes = {
	tab: shape({ id: string, name: string, url: string, type: string }),
};

export default ListSubmenu;
